module.exports = "/images/8d7a7845622ccc46d2c410a3257e57cf.svg";